exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img[data-v-32e13870]{background-repeat:no-repeat;background-size:cover;background-position:50%}@media screen and (max-width:900px){.img[data-v-32e13870]{height:50vh}}@media screen and (min-width:901px){.img[data-v-32e13870]{height:90vh}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32e13870","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/CarouselItem.vue
// module id = 52
// module chunks = 0